<template>
  <div class="store-wrapper">
    <div class="store">
      <div class="store-bar">
        <store-profile></store-profile>
      </div>
      <div class="main">
        <div class="user-list">
          <div class="card-title">
            Usuarios de la tienda
          </div>
          <div class="user">
            <div class="user-name">
              Oscar Labansat Cervantes
            </div>
            <div class="profile-button">
              Ir a usuario
            </div>
          </div>
          <div class="user">
            <div class="user-name">
              Oscar Labansat Cervantes
            </div>
            <div class="profile-button">
              Ir a usuario
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StoreProfile from '@/components/StoreProfile.vue';

export default {
  name: 'home',
  data() {
    return {
      currentComponent: 'records',
    };
  },
  components: {
    StoreProfile,
  },
};
</script>

<style lang="scss" scoped>
.store-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100vh;
}
.store {
  width: 900px;
  padding: 40px 0;
  display: flex;
  justify-content: space-between;
}
.store-bar {
  width: 34%;
}
.main {
  width: 64%;
}
.user-list {
  border-radius: 6px;
  padding: 24px;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.25);
  background-color: white;
}
.user {
  display: flex;
  border-radius: 6px;
  border: 1px solid #DCDEDD;
  justify-content: space-between;

  & + .user {
    margin-top: 14px;
  }
}
.user-name {
  padding: 14px 16px;
}
.profile-button {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: #f79916;
  display: flex;
  align-items: center;
  padding: 0 18px;
  color: white;
  cursor: pointer;
}
.card-title {
  font-size: 20px;
  margin-bottom: 18px;
}
</style>
